module.exports = __webpack_public_path__ + "144efd007d37619d96a6bcb176ab438c.svg";